import { useQuery } from "react-query";
import { clearStoredAuth } from "../utils";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import { API_URL } from "../config";

const fetchOpsMessages = async (params: string): Promise<OpsResponse> => {
  const res = await fetch(`${API_URL}/ops${params}`, {
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

export const useOpsMessages = (enabled: boolean) => {
  const navigate = useNavigate();

  return useQuery<OpsResponse, Error>(
    ["ops-messages"],
    () => {
      const date = dayjs().format("YYYY-MM-DD");
      return fetchOpsMessages(`?date=${date}&view=daily`);
    },
    {
      enabled,
      refetchInterval: enabled ? 60 * 1000 : false,
      refetchOnWindowFocus: false,
      retry: 1,
      onError: (error: Error) => {
        if (error.message === "401") {
          clearStoredAuth();
          navigate("/");
        }
      },
    }
  );
};
